export function getRickAiMarketingData() {
  try {
    const rickYmClientId = getFirst(document.getElementsByName('rick_ym_clientid'));
    const rickTempDealId = getFirst(document.getElementsByName('rick_temp_deal_id'));
    const rickDealMethod = getFirst(document.getElementsByName('rick_deal_method'));
    const rickRid = getFirst(document.getElementsByName('rick_rid'));
    const rickUrl = getFirst(document.getElementsByName('rick_url'));

    return { rickYmClientId, rickTempDealId, rickDealMethod, rickRid, rickUrl };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Failed to get RickAi data');
    // eslint-disable-next-line no-console
    console.warn(e);
  }
}
function getFirst(list: NodeListOf<HTMLElement>): string | null {
  if (list.item(0)) {
    const valueAttr = list.item(0).attributes.getNamedItem('value');
    if (valueAttr) {
      return valueAttr.value;
    }
  }
  return null;
}
